import { TitleStyleControl } from "@/overlay/components/QuickAccessLabel/ControlComponents/TitleStyleControl";
import styles from "@/overlay/components/QuickAccessLabel/QuickAccessLabel.module.scss";
import { classNames } from "@/utility/jsx";
import type { ElementStyle } from "@mm/metx-workbench.meteomatics.com";
import { type ReactNode, type Ref, forwardRef } from "react";

type LabelPopoverProps = {
  children: ReactNode;
  className?: string;
};

/** Container for a popover below the label, see `useLabelPopovers`. */
export const LabelPopover = forwardRef<HTMLDivElement, LabelPopoverProps>(function LabelPopover(
  { children, className },
  ref,
) {
  return (
    <div className={classNames(styles["label-right"], className)} ref={ref}>
      {children}
    </div>
  );
});

type LabelStylePopoverProps = {
  titleStyle: ElementStyle;
  onStyleChange: (newStyle: ElementStyle) => void;
  registerCloseHandler: (handler: (() => boolean) | null) => void;
  popoverRef: Ref<HTMLDivElement>;
  className?: string;
};

export function LabelStylePopover({
  titleStyle,
  onStyleChange,
  registerCloseHandler,
  popoverRef,
  className,
}: LabelStylePopoverProps) {
  return (
    <LabelPopover ref={popoverRef} className={className}>
      <TitleStyleControl
        titleStyle={titleStyle}
        onStyleChange={onStyleChange}
        registerCloseHandler={registerCloseHandler}
      />
    </LabelPopover>
  );
}
